import {
  post,
  postJson,
  deleteApi,
  put,
  get,
  imagePost,
  putJson,
  postBlob,
} from "./axios3";

import { putOne } from "./axios2";

const RESOURCE_BASE_PATH = "/paradiseAndTaskCommon";

const RESOURCE_BASE_PATH2 = "/pointsExchange";

const RESOURCE_BASE_PATH3 = "/image";

const RESOURCE_BASE_PATH4 = "/PointActivityAnalyticController";

const RESOURCE_BASE_PATH5 = "/bigTurntableDraw";

const RESOURCE_BASE_PATH6 = "/order-lottery";

// 分页获取活动列表(积分任务和积分乐园)
export const taskList = (p) => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 获取活动域名
export const prefixurl = (p) => get(`${RESOURCE_BASE_PATH}/prefixurl`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const exchangeActivityList = (p) =>
  postJson(`${RESOURCE_BASE_PATH2}/exchangeActivityList`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityList = (p) => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityVenderType = (p) =>
  postJson(`${RESOURCE_BASE_PATH2}`, p);

// 删除礼品兑换活动列表(兑换优惠券和兑换实物)
export const deleteActivityList = (id) =>
  deleteApi(`${RESOURCE_BASE_PATH2}/${id}`);

// 查询详情
export const inquireActivity = (id) => get(`${RESOURCE_BASE_PATH2}/${id}`);

// 修改详情
export const changeActivity = (p) => put(`${RESOURCE_BASE_PATH2}`, p);

// 上架下架礼品兑换
export const updateActivityList = (p) =>
  put(`${RESOURCE_BASE_PATH2}/status/${p.id}?status=${p.status}`);

// 上传图片
export const uploadpic = (p) => imagePost(`${RESOURCE_BASE_PATH3}/upload`, p);

//标记发货
export const changeStatus = (id) =>
  post(`${RESOURCE_BASE_PATH4}/markDeliveryStatus?id=${id}`);

//大转盘抽奖
export const bigTurntableDraw = (p) => postJson(`${RESOURCE_BASE_PATH5}`, p);

//修改大转盘抽奖
export const modifyBigTurn = (p) => putOne(`${RESOURCE_BASE_PATH5}`, p);

//大转盘抽奖详情
export const getbigTurn = (id) => get(`${RESOURCE_BASE_PATH5}/${id}`);

//下单有礼
export const bigTurntableDraw2 = (p) =>
  postJson(`${RESOURCE_BASE_PATH6}/save`, p);
//下单有礼详情
export const getOrderDraw = (id) => get(`${RESOURCE_BASE_PATH6}/get/${id}`);

//  人群
export const getPersonLabelList = (id) => get(`/giftBag/getPersonLabelList`);

// 创建开卡礼包
export const createShopGift = (p) => postJson(`/giftBag/createShopGift`, p);

// 获取礼包活动下单转化数据
export const getShopGif = (p) =>
  get(`/giftBag/getShopGiftParticipateConver`, p);

// 获取礼包模板列表数据
export const getGiftBagTemplate = (p) => get(`/giftBag/getGiftBagTemplate`, p);
// 获取礼包模板列表数据 分类 开卡 店铺 千人千面
export const getGiftBagList = (p) => get(`/giftBag/dir/list/${p}`);

// 修改礼包
export const editShopGift = (p) => postJson(`/giftBag/editShopGift`, p);

// 获取x详情   /jd-yusms-admin/giftbag/template/page
export const giftBagEide = (id) => get(`/giftBag/${id}`);

export const getValidActivity = (p) => get(`/giftBag/getValidActivity`);

// 创建店铺礼包千人千面
export const createThousandGift = (p) =>
  postJson(`/giftBag/createThousandGift`, p);

// 修改店铺礼包千人千面
export const editThousandGift = (p) => postJson(`/giftBag/editThousandGift`, p);

// 千人千面  查询
export const thousandGiftDetail = (id) =>
  get(`/giftBag/thousandGiftDetail/${id}`);

//首购 复购 下单有礼 创建
export const createPurchaseActivity = (p) =>
  postJson(`/purchaseActivity/create`, p);

// 首购 复购 下单有礼  查询
export const purchaseActivityDetail = (id) => get(`/purchaseActivity/${id}`);

// 首购 复购 下单有礼  修改
export const editPurchaseActivity = (p) => putOne(`/purchaseActivity/edit`, p);

// 云短信过期时间
export const publicOpen = (id) => get(`/public/open/jd-crm`);

// 创建评价有礼任务
export const commentCreate = (p) => postJson(`/comment/create`, p);

// 查询 评价有礼任务
export const getComment = (id) => get(`/comment/${id}`);

//评价有礼任务 修改
export const editCommentCreate = (p) => putOne(`/comment/edit`, p);

// 创建 裂变任务
export const splitCouponCreate = (p) => postJson(`/splitCoupon/save`, p);

// 查询 裂变任务
export const getSplitCoupon = (id) => get(`/splitCoupon/${id}`);

//裂变任务 修改
export const editSplitCoupon = (p) => postJson(`/splitCoupon/edit`, p);

// 创建 红包雨任务
export const redPacketCreate = (p) => postJson(`/red_packet_rain/save`, p);

// 查询 红包雨任务
export const getredPacket = (id) => get(`/red_packet_rain/details/${id}`);

// 创建 抓娃娃  大家来找茬任务
export const createGameHub = (p) => postJson(`/gameHub/create`, p);

// 修改 抓娃娃  大家来找茬任务
export const editGameHub = (p) => putJson(`/gameHub/edit`, p);

// 查询 抓娃娃  大家来找茬任务
export const getGameHub = (id) => get(`/gameHub/${id}`);

// 查询 大家一起来找擦模板集合
export const getGameTemplate = (id) => get(`/gameHub/gameTemplate`);

// 刮刮乐
export const saveScratchers = (p) => postJson(`/scratchers/saveOrUpdate`, p);
// 刮刮乐详情
export const editScratchers = (p) => get(`/scratchers/${p}`);
// 海报/
export const saveSmartPost = (p) => postJson(`/smart-post/saveOrUpdate`, p);

// 海报详情/jd-hd-web/
export const editSmartPost = (p) => get(`/smart-post/${p}`);

// id查活动时间
export const getActivityInfoFromUrl = (p) =>
  get(`/smart-post/getActivityInfoFromUrl/`, p);

//海报刮刮图片分类
export const getSystemTemplateGroup = (id) =>
  get(`/template/smartCard/getSystemTemplateGroup`, id);
//海报刮刮图片图片
export const sellerImage = (p) => postJson(`/sellerImage/list`, p);

//海报刮刮图片图片
export const zdImage = (p) => postJson(`/sellerImage`, p);

export const getmoble = (p) => get(`/taohd/current`, p);

export const getSellerCheckCode = (p) => get(`/seller/getSellerCheckCode`, p);

export const exportRecord = (p) =>
  postBlob(`/PointActivityAnalyticController/exportExchangeActivityRecord`, p);

  // 保存修改活动-会员卡片
export const freeTrialSave = p => postJson(`/freeTrial/saveOrUpdate`, p)
// 详情接口-会员卡片
export const freeTrialCardList = p => get(`/freeTrial/${p}`)

// 下单冲榜
export const createOrderRank = p => postJson(`/order-rank/save`, p)

//查询 
export const orderRankDetail = id => get(`/order-rank/detail/${id}`,)

//修改 
export const updateOrderRank = p => putOne(`/order-rank/update`,p)


//获取模板详情
export const getTemplate = (id) => get(`/template/getTemplate/${id}`);

//保存小部件模版
export const saveSmartCardTemplate = (p) => postJson(`/template/saveSmartCardTemplate`,p);

//删除自定义模版
export const delSmartCardTemplate = (id) =>
  deleteApi(`/template/delSmartCardTemplate/${id}`);